import {
    ILoginModel,
    ILoginResponseModel,
    ISignUpModel,
    IForgotPassword,
    IResetPassword,
    IUserOTPVerificationModel,
} from 'models/login';
import { AxiosResponse } from 'axios';
import baseService from 'services/base-service';
import { ApiResponseModel } from 'models/api';

const endPointBaseURL = `patients/Auth`;

const login = async (requestBody: ILoginModel): Promise<AxiosResponse<ApiResponseModel<ILoginResponseModel>>> =>
    baseService.post<ApiResponseModel<ILoginResponseModel>>(`${endPointBaseURL}/Login`, requestBody);

const logout = async (): Promise<AxiosResponse<ILoginResponseModel>> =>
    baseService.post<ILoginResponseModel>(`${endPointBaseURL}/Logout`);

const signIn = async (requestBody: ISignUpModel): Promise<AxiosResponse<ApiResponseModel<ILoginResponseModel>>> =>
    baseService.post<ApiResponseModel<ILoginResponseModel>>(`${endPointBaseURL}/SignUp`, requestBody);

const forgotPassword = async (
    requestBody: IForgotPassword,
): Promise<AxiosResponse<ApiResponseModel<ILoginResponseModel>>> =>
    baseService.post<ApiResponseModel<ILoginResponseModel>>(
        `${endPointBaseURL}/ForgotPassword?emailId=${requestBody.email}`,
    );

const resetPassword = async (
    requestBody: IResetPassword,
): Promise<AxiosResponse<ApiResponseModel<ILoginResponseModel>>> =>
    baseService.post<ApiResponseModel<ILoginResponseModel>>(`${endPointBaseURL}/ResetPassword`, requestBody);

const changePassword = async (
    requestBody: IResetPassword,
): Promise<AxiosResponse<ApiResponseModel<ILoginResponseModel>>> =>
    baseService.post<ApiResponseModel<ILoginResponseModel>>(`${endPointBaseURL}/changePassword`, requestBody);

const verifyOtp = async (
    requestBody: IUserOTPVerificationModel,
): Promise<AxiosResponse<ApiResponseModel<ILoginResponseModel>>> =>
    baseService.post<ApiResponseModel<ILoginResponseModel>>(`${endPointBaseURL}/VerifyOtp`, requestBody);

const resendOtp = async (email: string): Promise<AxiosResponse<ApiResponseModel<string>>> =>
    baseService.post<ApiResponseModel<string>>(`${endPointBaseURL}/ResendOtp?email=${email}`);

const validateSignUp = async (requestBody: ISignUpModel): Promise<AxiosResponse<ApiResponseModel<any>>> =>
    baseService.post<ApiResponseModel<any>>(`${endPointBaseURL}/ValidateSignUp`, requestBody);

export default {
    login,
    logout,
    signIn,
    forgotPassword,
    resetPassword,
    changePassword,
    verifyOtp,
    resendOtp,
    validateSignUp,
};
